import { Heading, Text, TextButton } from '@wix/design-system'
import { ChoiceQuestionContentComponent, useContent, useNext, usePageLoading } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { DesignSystemTokensLoader } from '../../../components/DesignSystemTokensLoader'
import { Button } from '../../reusable/Button'
import Logo from '../logo.svg'
import s from './HarmonySplit.scss'

type Content = {
  background: string
  title: string
  subtitle: string
  buttons: ChoiceQuestionContentComponent<Record<string, never>, { label: string }>
  disclaimer: string
}

export const HarmonySplit: FC = () => {
  const { content } = useContent<Content>()
  const pageLogger = usePageLogger()
  const next = useNext()
  const { questionKey, options } = content.buttons
  const [isPageLoading] = usePageLoading()

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  type Option = (typeof content.buttons.options)[number]
  const handleOptionClick = (option: Option) => {
    if (isPageLoading) {
      return
    }
    void pageLogger.answer({ questionName: questionKey, answer: 'skip' })
    next({ [questionKey]: { values: [option.optionKey] } })
  }

  return (
    <DesignSystemTokensLoader type="odeditor">
      <div style={{ backgroundImage: `url("${content.background}")` }} className={s.root}>
        <div className={s.box}>
          <Heading className={s.title}>
            {content.title}&nbsp;
            <Logo width="275px" height="43px" />
          </Heading>
          <Heading className={s.subtitle}>{content.subtitle}</Heading>
          <Button
            className={s.mainButton}
            skin="dark"
            label={options[0].label}
            onClick={handleOptionClick.bind(null, options[0])}
          />
          <br />
          <TextButton
            className={s.secondaryButton}
            skin="dark"
            underline="always"
            onClick={handleOptionClick.bind(null, options[1])}
          >
            {options[1].label}
          </TextButton>
          <br />
          <Text className={s.disclaimer}>
            {content.disclaimer}{' '}
            <a
              className={s.disclaimerLink}
              target="_blank"
              href="https://support.wix.com/en/article/introducing-the-wix-harmony-editor"
            >
              See full list
            </a>
            .
          </Text>
        </div>
      </div>
    </DesignSystemTokensLoader>
  )
}
